
import React, { Component } from 'react';
import ContainerPaper from '../paper/ContainerPaper';
import { withStyles } from '@material-ui/core/styles';
import HeaderDropDownSelector from '../common/dropdowns/header/HeaderDropDownSelector';

import {desktopContainerPaper } from '../../styles/shared/desktop';
import {desktopContentContainerPaperStyle, desktopHeaderDropdownStyleContainer} from './styles/desktop';

import CourseList from './CourseList';


const styles = theme => ({
    root: theme.mixins.gutters({
        marginTop: theme.spacing.unit * 3,
    })
});

class CourseTabs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            option: 0,
            value: 0
        }
        this.handleMenuChange = this.handleMenuChange.bind(this);    

    }
    
    generateSubjectList(coursesJson) {
        let courseSubjectList = [];
        coursesJson.map(function (subjectObj) {
            courseSubjectList.push(subjectObj.subject);
        })
        return courseSubjectList;
    }

    handleMenuChange(menuSelectionIndex) {
        this.setState({option: menuSelectionIndex})
    }

    render() {
        const { classes, children, style, deviceType, courseLevel, coursesJson } = this.props;
        let showMobile = deviceType === 'mobile' ? true : false;


        return (
            // <div>
            //     {/* <AppBarDesktop value={this.state.value} coursesJson={this.props.coursesJson} handleChange={this.handleChange} /> */}
            //         <SubjectTabContent value={this.state.value} deviceType={this.props.deviceType} coursesJson={this.props.coursesJson} />
            // </div>
            <div id={this.props.courseLevel + '-page-container'} style={{}}>
                <ContainerPaper style={desktopContainerPaper}>

                    <ContainerPaper id={this.props.courseLevel + '-page-sub-container'} style={desktopContentContainerPaperStyle}>
                        <div id={courseLevel + "-dropdown-container"} key={courseLevel + "-dropdown-container"} style={desktopHeaderDropdownStyleContainer}>
                            <HeaderDropDownSelector showMobile={showMobile} menuId={courseLevel + '-drop-down'}
                                optionsList={this.generateSubjectList(coursesJson)}
                                shouldDefault={true}
                                defaultValue={0}
                                handleSelection={this.handleMenuChange}
                            />
                        </div>
                        <CourseList courseLevel={courseLevel} subject={coursesJson[this.state.option]} />
                    </ContainerPaper>

                </ContainerPaper >
            </div >

        )
    }
}

export default withStyles(styles)(CourseTabs);


// WEBPACK FOOTER //
// ./src/components/course/CourseTabs.js